<template>
<div class="news_center ">
    <indexTitle english_title="Documentary" chinese_title="展覽紀實"  page='true'></indexTitle>
    <router-view></router-view>
</div>
    
</template>
<script>
import IndexTitle from '@/components/index/IndexTitle'
export default {
    components: {
        'indexTitle': IndexTitle,
    },
    metaInfo: {
      title: '展覽紀實│TopLink 上聯國際展覽有限公司', // set a title
      meta: [{                 // set meta
        name: 'description',
        content: '上聯國際展覽是國內展覽規模第一大的專業展覽公司。主要服務項目為承辦國內外各類型展覽，及展覽徵展業務、議題創意、媒體公關、展覽顧問、整合行銷規劃、國際策展交流等。世貿展,展覽資訊,展覽活動,近期展覽,展覽檔期,展覽公司,展覽好康,抽獎,免費門票'
      }]
    },
}
</script>
<style>

</style>


